import React from "react";
import PropTypes from "prop-types";
import { useTrans } from "../../../hooks";
import { Button, ButtonSize } from "@wattpad/web-ui-library";

const MobileDownloadPrompt = ({ onSendPromptEvent }) => {
  const { trans } = useTrans();
  const APP_LINK = "https://read.w.tt/f4RR/eadd1193";

  return (
    <div className="mobile-download-prompt">
      <div className="title">
        <span aria-hidden className="wattpad-logo" data-testid="wattpad-logo" />
        <span className="logo-text">
          {trans("Wattpad App - Unlock exclusive features")}
        </span>
      </div>
      <Button
        size={ButtonSize.SMALL}
        fullWidth
        href={APP_LINK}
        gtm="Download|bottom_banner|open_app"
        label={trans("Download the app")}
        onClick={() => onSendPromptEvent("click")}
      />
      <button className="bottom-login" data-form="login">
        {trans("Log in with browser")}
      </button>
    </div>
  );
};

MobileDownloadPrompt.propTypes = {
  onSendPromptEvent: PropTypes.func
};
export default MobileDownloadPrompt;
